import { useTheme } from '@emotion/react';

import type { IconComponent } from '@twistopayments/design-system/icons/constants';

import { useBannerContext } from '../../banner.context';

import * as styles from './banner-icon.styles';

type Props = {
  icon: IconComponent;
  className?: string;
};

export const BannerIcon = ({ icon, className }: Props) => {
  const theme = useTheme();
  const { size, variant, hasAction } = useBannerContext();

  const Icon = icon;
  const hasIconBackground = hasAction && size === 'medium';

  return (
    <div
      className={[className, 'banner-icon-wrapper'].filter(Boolean).join(' ')}
      css={[
        styles.container,
        theme.presentation.banner.iconOffset[size],
        hasIconBackground && styles.containerSize(theme),
        styles.iconColor[variant](theme),
        hasIconBackground && styles.containerBackground[variant](theme),
      ]}>
      <Icon
        className="banner-icon"
        color="inherit"
        css={[styles.iconSize[size](theme)]}
        size="inherit"
      />
    </div>
  );
};
